module.exports = __webpack_public_path__ + "img/bannerimg3.2a8a37ed.png";